import { Store, select } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import * as RA from 'ramda-adjunct';

import { State as CoreState } from './core.reducer';

export class CoreStoreService {

    dispatch: object;
    queries: object;

    constructor(protected store: Store<CoreState>) {}

    protected select(selector: any) {
        return this.store.pipe(select(selector));
    }

    protected selectNonNil(selector: any) {
        return this.select(selector).pipe(filter(RA.isNotNil));
    }
}
